import { Injectable } from '@angular/core';
import { EntityState, EntityStore, EntityUIStore, StoreConfig } from '@datorama/akita';
import { parseISO } from 'date-fns';
import { LogBookEntry } from '../../model/logbook-entry';

export interface MissionLogBookState extends EntityState<LogBookEntry> {
  hasMore: boolean;
  page: number;
};

export type MessageUI = {
  isRead: boolean;
  dateRead: Date;
  daysNotRead: number;
  type: string;
};

export type NotificationMessageUIState = EntityState<MessageUI>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'MissionLogBook' })
export class MissionLogBookStore extends EntityStore<MissionLogBookState> {
  ui: EntityUIStore<NotificationMessageUIState>;

  constructor() {
    super({ hasMore: true, page: 1 });
    this.createUIStore().setInitialEntityState({ isRead: false });

    this.akitaPreUpdateEntity = this.akitaPreUpdateEntity.bind(this);
    this.akitaPreAddEntity = this.akitaPreAddEntity.bind(this);
  }

  akitaPreAddEntity(entity: LogBookEntry) {
    const copyEntity = {...entity};
    copyEntity.dateIssuedDate = parseISO(entity.dateIssued.value);
    return copyEntity;
  }

  akitaPreUpdateEntity(entity: LogBookEntry){
      const copyEntity = {...entity};
      copyEntity.dateIssuedDate = parseISO(entity.dateIssued.value);
      return copyEntity;
    }
  }

